export default __webpack_public_path__ + "static/media/background-desktop.9e70e8fa.jpg";